var map = {
	"./partner_0.png": 611,
	"./partner_1.png": 306,
	"./partner_10.png": 72,
	"./partner_11.png": 201,
	"./partner_12.png": 770,
	"./partner_13.png": 683,
	"./partner_14.png": 284,
	"./partner_2.png": 313,
	"./partner_3.png": 208,
	"./partner_4.png": 431,
	"./partner_5.png": 334,
	"./partner_6.png": 101,
	"./partner_7.png": 972,
	"./partner_8.png": 267,
	"./partner_9.png": 506
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 154;